import React from "react"
import { ImageProps } from "../../../interfaces/image"
import SecondIcon from "../../../images/common/icons/columned/second.inline.svg"

export const Icon = ({ className, alt }: ImageProps) => {
  return <SecondIcon className={className} alt={alt} />
}
